{
  "titles": {
    "menu": "Klanten",
    "table": "Klanten",
    "general": "Algemeen",
    "facility": "Faciliteit",
    "currentAccountFacility": "Rekening-courant faciliteit",
    "companyInformation": "Bedrijfsinformatie",
    "partner": "Partner",
    "contactPerson": "Contactpersoon",
    "accounts": "Gebruikers",
    "creditOverview": "Kredietoverzicht",
    "defaultedOrIrrecoverableLoans": "In gebreke",
    "loans": "Leningen"
  },
  "fields": {
    "labels": {
      "status": "Status",
      "companyName": "Bedrijfsnaam",
      "contactPersonName": "Contactpersoon",
      "advisor": "Adviseur",
      "legalStructure": "Rechtsvorm",
      "registrationNumber": "KvK-nummer",
      "address": "Adres",
      "phone": "Telefoonnummer",
      "companyUrl": "Website",
      "customerSince": "Klant sinds",
      "name": "Naam",
      "email": "E-mailadres",
      "creditLimit": "Kredietlimiet",
      "withdrawnAmount": "Opgenomen krediet",
      "interestRate": "Tarief per 30 dagen",
      "previousLoanStartDate": "Datum laatste lening",
      "totalScheduledDirectDebitAmount": "Totaal toekomstige incasso's",
      "totalFailedDirectDebitsAmount": "Totaal gemiste incasso's",
      "totalPenaltyAmount": "Extra rentekosten",
      "totalAdministrationCosts": "Totaal administratiekosten",
      "totalOverdueAmount": "Totaal achterstallige betalingen"
    }
  },
  "messages": {
    "resubmitPreScanTooltip": "De Pre-Scan kan niet opnieuw worden ingediend, omdat de klant niet bekend is in het systeem.",
    "facilityIsBlocked": "Het krediet is geblokkeerd en tijdelijk niet toegankelijk voor de klant.",
    "blockedReasons": "Dit heeft de volgende reden(en):",
    "defaultedForAmount": "De klant is bij deze faciliteit in gebreke voor {amount}"
  },
  "actions": {
    "search": "Zoek een klant",
    "startPreScan": "Pre-Scan indienen",
    "resubmitPreScan": "Pre-Scan opnieuw indienen"
  }
}
